module.exports = __webpack_public_path__ + "media/images/padlock-28dda5480e0f887a63be49be46fc4f10.svg";